<app-side-menu>
  <div class="service-orders-consulta">

    <div *ngIf="error" class="alert alert-danger" role="alert">
      <i class="fas fa-exclamation-triangle"></i>
      {{ error }}
    </div>

    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="consultaFilterStatus" class="form-label">Filtrar por Status:</label>
          <select id="consultaFilterStatus" class="form-select" [(ngModel)]="selectedStatus">
            <option value="">Todos os Status</option>
            <option *ngFor="let status of statusOptions" [value]="status.name">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="consultaFilterConfigOrder" class="form-label">Filtrar por Tipo OS:</label>
          <select id="consultaFilterConfigOrder" class="form-select" [(ngModel)]="selectedConfigOrderId">
            <option [ngValue]="null">Todos os Tipos</option>
            <option *ngFor="let config of configOrderOptions" [ngValue]="config.id">
              {{ config.typeOS }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="consultaFilterOrderNumber" class="form-label">Nº OS:</label>
          <input id="consultaFilterOrderNumber" type="text" class="form-control" placeholder="Ex: OS-2026-0001"
            [(ngModel)]="filterOrderNumber" (keyup.enter)="search()">
        </div>

        <div class="filter-group">
          <label for="consultaFilterPlate" class="form-label">Placa:</label>
          <input id="consultaFilterPlate" type="text" class="form-control" placeholder="Ex: ABC1D23"
            [(ngModel)]="filterPlate" (keyup.enter)="search()">
        </div>

        <div class="filter-group">
          <label for="consultaFilterStartDate" class="form-label">Data Início:</label>
          <input id="consultaFilterStartDate" type="date" class="form-control" [(ngModel)]="filterStartDate">
        </div>

        <div class="filter-group">
          <label for="consultaFilterEndDate" class="form-label">Data Fim:</label>
          <input id="consultaFilterEndDate" type="date" class="form-control" [(ngModel)]="filterEndDate">
        </div>

        <div class="filter-group">
          <label for="consultaFilterB2b" class="form-label">Contrato B2B:</label>
          <input id="consultaFilterB2b" type="number" class="form-control" placeholder="ID do contrato"
            [(ngModel)]="filterB2bContractId" (keyup.enter)="search()">
        </div>

        <div class="filter-group">
          <label for="consultaFilterScheduled" class="form-label">Agendada:</label>
          <select id="consultaFilterScheduled" class="form-select" [(ngModel)]="filterIsScheduled">
            <option value="">Todas</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div>

        <div class="filter-actions">
          <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
          <button type="button" class="btn btn-primary" (click)="search()" [disabled]="loading">
            <i class="fas fa-search me-2"></i>
            Buscar
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="!hasSearched && !loading" class="consulta-empty-hint">
      <i class="fas fa-info-circle"></i>
      <p>Utilize os filtros e clique em <strong>Buscar</strong> para consultar ordens de serviço.</p>
    </div>

    <app-table
      *ngIf="hasSearched"
      [searchRight]="true"
      [data]="serviceOrders"
      [columns]="tableColumns"
      [loading]="loading"
      [actions]="tableActions"
      [clickable]="true"
      [showSearch]="true"
      [title]="'Resultado da Consulta'"
      searchPlaceholder="Buscar por OS, cliente, veículo..."
      [totalItemsFromBackend]="totalCount"
      [currentPageFromBackend]="currentPage"
      [itemsPerPage]="pageSize"
      [hasNextPageFromBackend]="currentPage < totalPages"
      [hasPreviousPageFromBackend]="currentPage > 1"
      [enableSorting]="true"
      (sortChange)="onSortChange($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="onTableAction($event)"
      (rowClick)="onRowClick($event)">
    </app-table>
  </div>
</app-side-menu>

<app-service-order-consulta-view-modal
  [show]="showViewModal"
  [serviceOrderId]="selectedServiceOrderId"
  (closeModal)="closeViewModal()">
</app-service-order-consulta-view-modal>
